import styled from "styled-components";
import theme from 'common/theme';

export const CenterCellContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .value {
    font-size: 1.6em;
    font-weight: 600;
  }

  .title, .label {
    color: ${theme.colors.label};
    font-weight: 500;
    text-transform: capitalize;
    font-size: 0.9em;
  }
`